export default "__VITE_ASSET__CLGnXlWC__"